import { actions } from '@store/session';
import { Fetch } from '@store/session/service';
import rootReducer from '@store/reducers';
import { configureStore, getDefaultMiddleware, } from '@reduxjs/toolkit';
var store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState: {},
    middleware: getDefaultMiddleware().concat(function (_a) {
        var dispatch = _a.dispatch;
        return function (next) { return function (action) {
            if (/\/rejected$/.test(action.type) !== true || action.error === void 0) {
                return next(action);
            }
            var code = Number(action.error.code);
            var message = action.error.message;
            switch (true) {
                /** 获取当前用户信息时，发生错误 */
                case action.type === Fetch.rejected.type:
                    dispatch(actions.unauthorized({ code: code, message: message }));
                    break;
                case action.error.name === 'HttpError' /** http 请求错语 */:
                case action.error.name === 'NetworkError' /** 网络错误 */:
                    switch (code) {
                        case 401 /** 请求被拒绝，身份认证失败时 */:
                            dispatch(actions.unauthorized({ code: code, message: message }));
                            break;
                        case 408 /** 网络错误 */:
                            console.error(new Error(message));
                            break;
                        default:
                            break;
                    }
                    break;
                default:
                    break;
            }
            return next(action);
        }; };
    }),
});
export default store;
